import React, { FC, memo } from 'react';

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    FlexColumn,
    SvgIcon,
} from '@portal/common/components';
import theme from '@portal/common/theme';

import { DataTypeRecord, accordionDetailsStyle } from './DataLicenseView';
import DataTypeRow from './DataTypeRow';
import SummaryRow from './SummaryRow';

const titleStyles = {
    [`:hover > div:firstChild`]: {
        color: `${theme.color.green1}`,
    },
};

const iconStyle = { marginRight: 15 };

type Props = {
    collection: [number, string, number, DataTypeRecord[], string];
};

const folderIcon = (
    <SvgIcon
        src="/icons/ic-folder.svg"
        color={(theme) => theme.color.green1}
        size="large"
        style={iconStyle}
    />
);

export const CollectionRow: FC<Props> = memo(
    ({ collection: [id, name, total_percentage, dataTypeRecords, dataProjectName] }) => (
        <div>
            <Accordion id={`${id}`}>
                <AccordionSummary style={titleStyles} arrowSize="medium">
                    <SummaryRow
                        dataName="data"
                        name={name}
                        percentage={total_percentage}
                        icon={folderIcon}
                        dataProjectName={dataProjectName}
                    />
                </AccordionSummary>
                <AccordionDetails style={accordionDetailsStyle}>
                    <FlexColumn grow={1}>
                        {dataTypeRecords.map((record) => (
                            <DataTypeRow key={record[0]} data={record} dataCollectionId={id} />
                        ))}
                    </FlexColumn>
                </AccordionDetails>
            </Accordion>
        </div>
    )
);

export default CollectionRow;
